import React, { Component }  from 'react';
import SearchBox from '../SearchBox';
import ProductionOrderList from '../ProductionOrderList';
import { GETACTIVEPRODUCTIONORDERS, SEARCHPRODUCTIONORDERS } from '../../constants/Config';
import { useTranslation, Trans } from 'react-i18next';
import { toast } from 'react-toastify';
const { t } = useTranslation();

class ProductionOrderIndexPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
          error: null,
          isLoaded: false,
          orders: [],
          recentorders: []
        };
        this.searchOrdersWithFilter = this.searchOrdersWithFilter.bind(this);
      }
    _isMounted = false;
    componentDidMount() {
        this.props.setHeader();
        this._isMounted = true;

        if(this.props.searchText != "") {
            this.searchOrdersWithFilter(this.props.searchText);
        }

        fetch(GETACTIVEPRODUCTIONORDERS + "5", {method: 'GET'})
        .then((response) => {
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                if (!response.ok) {
                    const error = (data && data.message) || response.statusText;
                    toast.error(error, {
                        position: toast.POSITION.TOP_CENTER
                      });
                    return Promise.reject(error);
                }
        
                return data;
            });
        })
        .then((res) => {
            if (this._isMounted) {
                this.setState({
                isLoaded: true,
                recentorders: res.results
                });
            }

            if(res.results.length === 0) {
                toast.info(<Trans>{t('NoOrders')}</Trans>, {
                    position: toast.POSITION.TOP_CENTER
                  });
            }

            return true;
        })
        .catch(function(error) {
            toast.error(error, {
                position: toast.POSITION.TOP_CENTER
              });
        });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }
    
    searchOrdersWithFilter(filter) {
        if(filter.trim() !== "") {
            fetch(SEARCHPRODUCTIONORDERS + filter +"/5", {method: 'GET'})
            .then((response) => {
                return response.text().then(text => {
                    const data = text && JSON.parse(text);
                    if (!response.ok) {
                        const error = (data && data.message) || response.statusText;
                        toast.error(error, {
                            position: toast.POSITION.TOP_CENTER
                        });
                        return Promise.reject(error);
                    }
                    return data;
                });
            })
            .then((res) => {
                if(res.succeeded === false) {
                    for (let index = 0; index < res.messages.length; index++) {
                        toast.error(res.messages[index], {
                            position: toast.POSITION.TOP_CENTER
                        });
                    }
                    return Promise.reject();
                }
                this.setState({
                isLoaded: true,
                orders: res.results
                });

                if(res.results.length === 0) {
                    toast.info(<Trans>{t('NoOrders')}</Trans>, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }

                this.props.setProdOrderHist(filter);
                return true;
            })
            .catch(function(error) {
                toast.error(error, {
                    position: toast.POSITION.TOP_CENTER
                  });
            });        
        } else {
            toast.info(<Trans>{t("FillSearchField")}</Trans>, {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }

    render() {
        return (
            <React.Fragment>
                <SearchBox SearchOrders={this.searchOrdersWithFilter} searchText={this.props.searchText}></SearchBox>
                <ProductionOrderList actions={this.props.actions} editTitle={<Trans>{t('Edit')}</Trans>} orders= {this.state.orders} title={<Trans>{t('SearchOrders')}</Trans>}></ProductionOrderList>
                <ProductionOrderList actions={this.props.actions} editTitle={<Trans>{t('Edit')}</Trans>} orders= {this.state.recentorders}  title={<Trans>{t('RecentOrders')}</Trans>}></ProductionOrderList>
            </React.Fragment>
        )
    }
}

export default ProductionOrderIndexPage;